module.exports = __webpack_public_path__ + "static/media/promo.770074c2.png";